<template>
  <RevDrawer
    name="SELLER_FLASH_SALES"
    :title="i18n(translations.modalHeader)"
    @open="handleOpen"
  >
    <template #body>
      <RevLoadingScreen
        v-if="pending"
        class="h-full"
        :text="i18n(translations.loading)"
      />
      <div v-else class="space-y-16">
        <div v-for="product in products" :key="product.listingId">
          <ProductCard
            :id="product.id"
            :brand="product.brandClean"
            :category="product.category"
            :category-id="product.categoryId"
            :color-swatches="product.specifications?.color ?? []"
            :deal="product.deal"
            :description="product.description"
            :discounted-price="product.discountedPrice"
            :grade="product.grade.name"
            :granularity="product.granularity"
            :image-alt="product.title"
            :image-src="product.image"
            :listing-id="product.listingId"
            :model="product.modelClean"
            :price="product.price"
            :price-new="product.priceNew"
            :product
            :review-rating="product.reviewRating"
            :scores="product.scores"
            :specifications="
              Object.entries(product.specifications ?? {})
                .map(([key, values]) => ({
                  label: key,
                  values: values.map(
                    ({ name, value }) => name + (value ? ` (${value})` : ''),
                  ),
                }))
                .filter(({ label }) => !excludedSpecifications.has(label))
            "
            :tags="product.marketingTags"
            :title="product.title"
            :url="product.productPageLink"
            :with-starting-from="product.granularity === 'parent'"
            @add-to-cart="handleProductCardAction"
            @link-click="handleProductCardAction"
          />
        </div>
      </div>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'
import { RevLoadingScreen } from '@ds/components/LoadingScreen'
import { closeModal } from '@ds/components/ModalBase'

import ProductCard from '@backmarket/nuxt-layer-recommendation/ProductCard.vue'

import { useSellerFlashSalesModal } from '../../../composables/useSellerFlashSalesModal'

import translations from './SellerFlashSalesModal.translations'

const i18n = useI18n()

const { productId } = defineProps<{
  productId: string
  productName: string
}>()

const {
  data: products,
  pending,
  refresh: fetchProducts,
} = useSellerFlashSalesModal(productId)
const excludedSpecifications = new Set(['color', 'storage'])

function handleOpen() {
  fetchProducts()
}

function handleProductCardAction() {
  closeModal('SELLER_FLASH_SALES')
}
</script>
